// extracted by mini-css-extract-plugin
export var copyableField = "_m9-4";
export var customerBadge = "_m9-0";
export var customerInfoTitle = "_m9-2";
export var details = "_m9-1";
export var dropdownContainer = "_m9-5";
export var dropdownImage = "_m9-6";
export var editAssigneeForm = "_m9-a";
export var editButton = "_m9-3";
export var email = "_m9-7";
export var hidden = "_m9-d";
export var input = "_m9-8";
export var saveButton = "_m9-b";
export var shopifyIcon = "_m9-c";
export var suggestionBadge = "_m9-e";
export var suggestionText = "_m9-f";
export var username = "_m9-9";